"use client";

import { cn } from "@/lib/utils/cn";
import { Typography } from "./Typography";

interface BacktrackableTextProps {
  children: string;
  onClick?: () => void;
  className?: string;
}

export function BacktrackableText({
  children,
  onClick,
  className,
}: BacktrackableTextProps) {
  return (
    <Typography
      as="span"
      variant="body"
      color="light"
      truncate
      className={cn(
        onClick &&
          "cursor-pointer transition-colors hover:text-blue-600 hover:underline focus-visible:text-blue-600 focus-visible:underline focus-visible:outline-none",
        className,
      )}
      onClick={
        onClick
          ? (event) => {
              event.stopPropagation();
              onClick();
            }
          : undefined
      }
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                event.stopPropagation();
                onClick();
              }
            }
          : undefined
      }
    >
      {children}
    </Typography>
  );
}
